import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteHotel, getHotels, resetState } from "../features/laxuryHotelSclice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "NAME",
    dataIndex: "name",
  },
  {
    title: "TITLE",
    dataIndex: "title",
  },
  {
    title: "Address",
    dataIndex: "address",
  },
  {
    title: "Country",
    dataIndex: "country",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Associationlist = () => {
  const [open, setOpen] = useState(false);
  const [AssociationId, setAssociationId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setAssociationId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const token = useSelector((state) => state.autht.token);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getHotels(token));
  }, []);
  
  const getAssociationState = useSelector((state) => state.laxuryHotelS.Hotels);
  console.log(getAssociationState);
  const data1 = [];
  console.log(getAssociationState.length);
  for (let i = 0; i < getAssociationState.length; i++) {
    data1.push({
      key: i + 1,
      name: getAssociationState[i].name, 
      title: getAssociationState[i].title,
      address: getAssociationState[i].address,
      country: getAssociationState[i].country,
      action: (
        <>
          <Link
            to={`/Hotel/AddHotel/${getAssociationState[i]._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getAssociationState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNews = (e) => {
    dispatch(deleteHotel(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getHotels(token));
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Hotels List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(AssociationId);
        }}
        title="Are you sure you want to delete this Association?"
      />
    </div>
  );
};

export default Associationlist;
